import { useTranslation } from "react-i18next";
import Modal from "./atoms/Modal";

interface SessionExpiredDialogProps {
  open: boolean;
  onStay: () => void;
  onLoginAgain: () => void;
}

const SessionExpiredDialog = ({ open, onStay, onLoginAgain }: SessionExpiredDialogProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={open}
      setIsOpen={nextOpen => {
        if (!nextOpen) onStay();
      }}
      title={t("sessionExpired.title")}
      body={<p className="mt-3 text-gray-600">{t("sessionExpired.description")}</p>}
      bottom={
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" className="rounded-md border border-vcolor px-4 py-2 text-vcolor" onClick={onStay}>
            {t("sessionExpired.stay")}
          </button>
          <button type="button" className="rounded-md bg-vcolor px-4 py-2 text-white" onClick={onLoginAgain}>
            {t("sessionExpired.loginAgain")}
          </button>
        </div>
      }
    />
  );
};

export default SessionExpiredDialog;
